/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { Component } from 'react';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import * as S from './styles';
import './style.css';

interface IProps {
  slider?: any[];
}

const ImageSliderVW = (props: IProps) => {
  const sliderItems = () => {
    let _slider = props?.slider?.map((item, index) => {
      if (item?.type === 'image') {
        return (
          <div className="each-fade" key={item?.key}>
            <div key={item?.key} className="image-container">
              <img
                alt="Vantr"
                className={'img-fluid'}
                src={item?.url}
                width={'100%'}
                height={'70%'}
              />
            </div>
          </div>
        );
      } else
        return (
          <div key={item?.key} className="image-container">
            <S.VideoContainer>
              <video
                style={{
                  objectFit: 'cover',
                  width: '100%',
                  height: 'auto',
                }}
                autoPlay={true}
                loop={true}
                muted={true}
                playsInline={true}
                src={item?.url}
              />
            </S.VideoContainer>
          </div>
        );
    });
    return _slider;
  };
  return (
    <S.Container>
      <div className="slide-container">
        <Slide {...props} indicators={true} arrows={true}>
          {sliderItems()}
        </Slide>
      </div>
    </S.Container>
  );
};

export default ImageSliderVW;
